<ion-header class="ion-no-border header">
    <ion-toolbar>
        <ion-buttons slot="start">
            <lib-icon-button
                (onClick)="closeModal()"
                iconName="chevron-left"
            />
        </ion-buttons>
        <ion-title class="text-center">Your location or area</ion-title>
        <ion-buttons slot="end">
            <lib-svg-icon
                color="transparent"
                iconName="chevron-left" />
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
    <lib-places-autocomplete-input
        (selectedAddress)="onPlacesAddressSelect($event)"
        [label]="undefined"
        [showLocationIcon]="true"
        placeholder="Your location"
    >
    </lib-places-autocomplete-input>

    <lib-use-my-location (addressFound)="onAddressSelected($event)"></lib-use-my-location>
</ion-content>